import { EmptyBookingPartner } from '~/components/booking-review/booking-partner';
import { AppointmentInformation } from '../components';


export const config = {
  BookingInformation: {
    appointmentInformation: AppointmentInformation,
  },
  BookingReview: {
    displayUserAddress: true,
    hideShopDetails: true,
    hidePartnerDetails: true,
    BookingHeader: {
      departmentTitle: 'Fitted Bedrooms',
    },
    BookingPartner: EmptyBookingPartner,
  },
};
